import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// 域名验证：只允许 *.mvp56.com 域名访问
function checkDomain() {
  const hostname = window.location.hostname;
  // 匹配 mvp56.com 或任何子域名 *.mvp56.com
  const allowedPattern = /^(.+\.)?mvp56\.com$/i;
  return allowedPattern.test(hostname);
}

// 只有在允许的域名下才渲染应用
if (checkDomain()) {
  new Vue({
    render: h => h(App),
  }).$mount('#app')
} else {
  // 非授权域名，清空页面内容，显示空白
  document.body.innerHTML = '';
  document.body.style.cssText = 'margin:0;padding:0;background:#fff;';
}
